const eventSorting = {
  recommendedDesc: {
    displayName: 'Recommended first',
    field: 'isInProgress',
    order: 'desc'
  },
  startDateDesc: {
    displayName: 'Date (Latest)',
    field: 'eventDate',
    order: 'desc'
  },
  startDateAsc: {
    displayName: 'Date (Earliest)',
    field: 'eventDate',
    order: 'asc'
  },
  cpdPointsDesc: {
    displayName: 'Most CPD hours first',
    field: 'cpdPoints',
    order: 'desc'
  },
  cpdPointsAsc: {
    displayName: 'Least CPD hours first',
    field: 'cpdPoints',
    order: 'asc'
  },
  durationAsc: {
    displayName: 'Shortest duration',
    field: 'estimatedReadingTime',
    order: 'asc'
  },
  durationDesc: {
    displayName: 'Longest duration',
    field: 'estimatedReadingTime',
    order: 'desc'
  }
};

export default eventSorting;



// WEBPACK FOOTER //
// ./src/constants/event-sorting.js